import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MessagesModule } from 'app/layout/common/messages/messages.module';
import { NotificationsModule } from 'app/layout/common/notifications/notifications.module';
import { UserModule } from 'app/layout/common/user/user.module';
import { SharedModule } from 'app/shared/shared.module';
import { ThinLayoutComponent } from 'app/layout/layouts/vertical/thin/thin.component';
import { BreadcrumbModule } from 'app/layout/common/breadcrumb/breadcrumb.module';
import { BroadcastModule } from 'app/layout/common/broadcast/broadcast.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { ZuperNavigationModule } from '@zuper/components/zuper-navigation';
import { DialerButtonComponent } from 'app/modules/dialer/dialer-button/dialer-button.component';
import { DialerOverlayComponent } from 'app/modules/dialer/dialer-component/dialer-overlay.component';
import { TaskingButtonComponent } from 'app/components/tasking/tasking-button/tasking-button.component';
import { TaskingDrawerComponent } from 'app/components/tasking/tasking-drawer/tasking-drawer.component';

@NgModule({ declarations: [
        ThinLayoutComponent,
    ],
    exports: [
        ThinLayoutComponent
    ], imports: [
        CommonModule,
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MessagesModule,
        NotificationsModule,
        UserModule,
        SharedModule,
        BreadcrumbModule,
        BroadcastModule,
        OverlayModule,
        ZuperNavigationModule,
        DialerButtonComponent,
        DialerOverlayComponent,
        TaskingButtonComponent,
        TaskingDrawerComponent
    ], providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class ThinLayoutModule {
}
